<template>
  <content-box class="confirm--wrap" :width="'830px'">
    <p class="title">{{ $t('userInfo.myInformation.deactivate.title') }}</p>
    <form>
      <fieldset class="field__password">
        <input type="text" autocomplete="username" hidden>
        <ui-input-text
          :id="'password'"
          :type="'password'"
          :isInputAbove="false"
          :modelError="modelError.userPw"
          :placeholder="$t('common.placeHolder.enterPassword')"
          @input="getPasswordValue"
          @onFocus="modelError.userPw = ''">
          {{ $t('userInfo.myInformation.deactivate.password.label') }}
        </ui-input-text>
      </fieldset>
      <fieldset class="field__reason">
        <div class="reason--wrap">
          <p class="label" v-html="$t('common.whyLeavingUs.desc.deactivate')"></p>
          <ul class="reason__list clearfix">
            <li v-for="item in orderedReason"
                class="item"
                :key="item.type">
              <label class="label" :for="item.value">
                <input type="radio"
                       name="withDrawReason"
                       :id="item.value"
                       :value="item.type"
                       v-model="model.deactivateReasonType"><i class="icon icon--radio-off"></i>
                {{ $t(`common.whyLeavingUs.${item.value}`) }}
              </label>
              <div v-if="item.type === '0'" class="other-reason--wrap">
                <ui-input-text
                  class="input__other-reason"
                  :disabled="model.deactivateReasonType !== '0'"
                  :type="'text'"
                  :isInputAbove="false"
                  :placeholder="''"
                  @onFocus="modelError.deactivateReasonText = ''"
                  @input="getOtherReason">
                </ui-input-text>
                <strong v-if="modelError.deactivateReasonText" class="validation-text">
                  {{ $t(`common.validationErrorText.requiredReasonText`) }}
                </strong>
              </div>
            </li>
          </ul>
        </div>
        <div class="button--wrap">
          <ui-button class="btn__cancel"
                     :primary2="true"
                     @click="onCloseLayer">{{ $t('common.cancel') }}</ui-button>
          <ui-button class="btn__confirm"
                     :primary="true"
                     :disabled="!model.userPw || (model.deactivateReasonType === '0' && !model.deactivateReasonText)"
                     @click="onConfirmDelete">{{ $t('common.confirm') }}</ui-button>
        </div>
      </fieldset>
    </form>
  </content-box>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'
import UiInputText from '@/components/ui/UiInputText'
import { mapState, mapMutations } from 'vuex'
import { deactivate } from '@/api/user'
import { storageManager } from '@/libs/storage-manager'
import { removeAuthData } from '@/libs/auth-helper'

export default {
  components: {
    ContentBox,
    UiButton,
    UiInputText
  },
  name: 'deactivate',
  data () {
    return {
      model: {
        userPw: '',
        deactivateReasonType: '5',
        deactivateReasonText: ''
      },
      modelError: {
        userPw: '',
        deactivateReasonText: ''
      },
      reason: [
        {
          type: '0',
          order: 6,
          value: 'otherReasons'
        },
        {
          type: '1',
          order: 4,
          value: 'manyError'
        },
        {
          type: '2',
          order: 1,
          value: 'notHaveFeature'
        },
        {
          type: '3',
          order: 5,
          value: 'otherService'
        },
        {
          type: '4',
          order: 2,
          value: 'barelyUse'
        },
        {
          type: '5',
          order: 3,
          value: 'difficultUse'
        }
      ]
    }
  },
  computed: {
    ...mapState([
    ]),
    orderedReason () {
      let orderReasonList = this.reason.slice()
      orderReasonList.sort((a, b) => {
        return a.order - b.order
      })
      return orderReasonList
    }
  },
  methods: {
    ...mapMutations([
      'clearAllUserData'
    ]),
    onCloseLayer () {
      this.$emit('onCloseLayer')
    },
    getPasswordValue (value) {
      this.model.userPw = value
    },
    getOtherReason (value) {
      this.model.deactivateReasonText = value
    },
    onConfirmDelete () {
      if (!this.model.userPw.length) {
        this.modelError.userPw = 'requiredPassword'
        return false
      }
      if (this.model.userPw.length < 6) {
        this.modelError.userPw = 'passwordInsufficient'
        return false
      }
      if (this.model.deactivateReasonType === '0' && !this.model.deactivateReasonText.length) {
        this.modelError.deactivateReasonText = 'requiredReasonText'
        return false
      }
      const param = {
        ...this.model
      }
      param.deactivateReasonText = this.model.deactivateReasonType === '0' ? this.model.deactivateReasonText : ''
      deactivate(param).then(response => {
        this.clearAllUserData()
        storageManager.removeUserData()
        removeAuthData()
        this.$router.push({ name: 'deactivate', params: { isCompleteUser: true } })
      }).catch(err => {
        // todo: clear user data
        if (err.message === 'Wrong password') {
          this.modelError.userPw = 'wrongPassword'
        } else {
          console.error(err)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.confirm--wrap {
  padding: 30px;
  text-align: left;
  .title {
    font-size: 15px;
    font-weight: 600;
    color: #2f2f2f;
  }
  .field__password {
    margin-top: 20px;
    border-radius: 5px;
    border: solid 1px #d7d7d7;
    background-color: #f4f4f4;
    padding: 30px;
    box-sizing: border-box;

    /deep/ .input--wrap {
      .label {
        margin-bottom: 20px;
        font-size: 14px;
        font-weight: 600;
        color: #666666;
      }
      .input-element {
        width: 370px;
      }
    }
  }
  .field__reason {
    margin-top: 40px;

    .label {
      font-size: 14px;
      font-weight: 600;
      color: #767676;
      line-height: 1.75;
    }

    .reason__list {
      .item {
        width: 50%;
        float: left;
        margin-top: 22px;
        .label {
          font-size: 13px;
          color: #2f2f2f;
          cursor: pointer;
        }
        .icon {
          vertical-align: middle;
          margin-right: 6px;
        }
        input[type='radio'] {
          opacity: 0;
          width: 0;
          height: 0;
          position: absolute;
          top: 0;
          left: 0;
          overflow: hidden;
          text-indent: -9999px;
        }
      }

      .other-reason--wrap {
        position: relative;

        .validation-text {
          @include validErrorText;
          position: absolute;
          left: 36px;
          bottom: -20px;
        }

        .input__other-reason {
          width: 346px;
          margin-left: 25px;
        }
      }
    }
  }
  .button--wrap {
    margin-top: 40px;
    text-align: center;

    .ui-btn {
      padding: 0 30px;

      &.btn__cancel {
        margin-right: 5px;
      }
    }
  }
}
</style>
